import * as prismic from "@prismicio/client";

export const repositoryName = "andycary-portfolio";

// Only create the client if the access token is available
export const client = process.env.REACT_APP_PRISMIC_ACCESS_TOKEN 
  ? prismic.createClient(repositoryName, {
      accessToken: process.env.REACT_APP_PRISMIC_ACCESS_TOKEN,
    })
  : null;

// Helper function to check if Prismic is properly configured
export const isPrismicConfigured = () => {
  return !!process.env.REACT_APP_PRISMIC_ACCESS_TOKEN;
};

// Custom hook to safely use Prismic documents
export const useSafePrismicDocument = (documentType) => {
  if (!isPrismicConfigured() || !client) {
    return [{ data: null }, { state: 'failed' }];
  }
  
  // This will be replaced by the actual Prismic hook when available
  return [{ data: null }, { state: 'failed' }];
};
